import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import {followUpEnum, stepEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import {CSSTransition} from 'react-transition-group';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import TextInput from '../../../Shared/TextInput/TextInput';
import ChevronArrow from '../DebtPaymentComponents/chevronArrow';
import {report, getReportParams} from '../../../../middleware/report';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const DebtPaymentSelectAmountPrivate = (props) => {
  const [mount, setMount] = useState(false);
  const [amount, setAmount] = useState(props.maxAmount);
  const [isShowExtra, setShowExtra] = useState(false);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.currentStep === stepEnum.SELECTAMOUNT) {
          setMount(true);

          let reportParams = getReportParams();
          reportParams.area = 'SelfCare';
          reportParams.subArea = 'Private Debt Payment';
          reportParams.channel = 'WebsitePrivate';
          reportParams.actionType = 'Debt Sum Page';
          reportParams.status = 'Ongoing';
          reportParams.banId = props.savedCustomerData?.number;
          reportParams.idNumber = props.savedCustomerData?.idNumber;
          reportParams.messageText = 'Debt Sum Page Displayed';
          reportParams.subscriber = props.phoneNumber;
          reportParams.param1 = `סה"כ יתרה: ` + props.maxAmount + '₪';
          reportParams.param2 = `סכום לתשלום: ` + props.maxAmount + '₪';
          reportParams.customerName = props.savedCustomerData?.name;
          report(reportParams);
        } else {
          setMount(false);
        }
      }
    },
    [props.currentStep],
  );

  useEffect(() => {
    if (props.maxAmount && mount) {
      setAmount(props.maxAmount);
    }
  }, [props.maxAmount, mount]);

  const canAdvance = () => {
    return amount >= 0 && amount <= props.maxAmount;
  };

  const advanceToCG = () => {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Private Debt Payment';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = 'Debt Sum Page';
    reportParams.status = 'Ongoing';
    reportParams.banId = props.savedCustomerData?.number;
    reportParams.idNumber = props.savedCustomerData?.idNumber;
    reportParams.messageText = 'Debt Sum Page Button Clicked';
    reportParams.subscriber = props.phoneNumber;
    reportParams.param1 = `סה"כ יתרה: ` + props.maxAmount + '₪';
    reportParams.param2 = `סכום לתשלום: ` + amount + '₪';
    reportParams.customerName = props.savedCustomerData?.name;
    report(reportParams);
    if (canAdvance()) props.handler(amount);
  };
  const extraPaymentData = isShowExtra && (
    <>
      <div className='extraPaymentDataCol'>
        <BasicText text={'יתרת חוב: ₪' + props.savedData.monthlyBalance + ''} />
        <BasicText text={'יתרת חוב חשבונית חדשה: ₪' + props.savedData.invoiceBalance + ''} />
      </div>
    </>
  );
  return (
    <CSSTransition key={2} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={`הגדירו את הסכום לחיוב`} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='justify-content-md-center'>
          <Col md='auto'>
            <div className='insertAmountPaymentData'>
              <div
                className={`paymentAmountTip ${isShowExtra ? 'active' : ''}`}
                onClick={() => {
                  setShowExtra(!isShowExtra);
                }}>
                <BasicText text={'יתרה לתשלום: ₪' + props.maxAmount + ''} classname={'consumerSelectInlinePayment'} bold={true} />
                <ChevronArrow />
              </div>
              {extraPaymentData}
            </div>
          </Col>
        </Row>
        <Row className='justify-content-md-center'>
          <Col md='auto'>
            <BasicText color='amountSelectAmount' text={`נא עדכן את הסכום אותו תרצה לשלם`} />
          </Col>
        </Row>
        <Row className='justify-content-md-center'>
          <div className='privateAmountInput'>
            <TextInput
              autoComplete='off'
              placeholder='סכום לתשלום'
              value={amount}
              type='number'
              error={
                canAdvance() && amount != '' && amount != NaN ? null : 'גובה הסכום לתשלום לא יכול להיות גבוה מהיתרה לתשלום ונמוך/שווה ל-0'
              }
              onChange={(e) => setAmount(parseFloat(e.target.value))}
            />
          </div>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto' className={`${!canAdvance() ? 'disabled-btn' : ''}`}>
            <BtnSubmit isBusiness={false} text={'המשך למסך תשלום'} onclick={() => advanceToCG()} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentSelectAmountPrivate;
